import { InjectionToken } from "@angular/core";
import { IBillingRestClient } from "./i-billing-rest.client";

export const billingRestClientInjectionToken: InjectionToken<IBillingRestClient> = new InjectionToken<IBillingRestClient>("digital-signage.user-dashboard.dashboard-web.BillingRestClient");
